<template>
  <b-modal
    id="destroy-account"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="destroyAccount"
    @hidden="clearOptions"
  >
    <template v-slot:modal-title>
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="text-center">
          <BaseIcon
              size="medium"
          >
            <WarningIcon />
          </BaseIcon>
          <h2 class="font-weight-bold font-size-medium text-color2">Atenção!</h2>
          <p>Ao confirmar abaixo, sua conta será deletada, bem como todos os conteúdos (publicações, listas, comentários, etc) vinculados a ela.</p>
          <p>Essa ação é <strong class="text-color2">irreversível</strong>.</p>
          <form
              action=""
              method="POST"
              class="mt-4 default-form"
              @submit.prevent="submit"
          >
            <div class="form-group">
              <div class="styled-checkbox">
                <label for="confirm">
                  <input
                    id="confirm"
                    type="checkbox"
                    v-model="$v.confirmation.option.$model"
                    :value="true"
                  />
                  <span></span>
                  Sim, eu desejo apagar minha conta
                </label>
              </div>
            </div>
            <div class="mt-3 text-center">
              <Button
                  class="btn-primary btn-sm mr-2"
                  :loading="loader"
                  @click="submit"
                  :disabled="$v.$invalid"
              >
                  Apagar conta
              </Button>
              <Button
                class="btn-outline-color2 btn-sm"
                @click="hide"
              >
                Cancelar
              </Button>
            </div>
          </form>
      </div>
    </template>
  </b-modal>
</template>

<script>

import UserService from '@/modules/users/services/users-service'
import { parseErrorResponseToArray } from '@/utils'
import AuthService from '@/modules/auth/services/auth-service'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button.vue'
import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import WarningIcon from '@/components/common/Icon/WarningIcon.vue'

export default {
  name: 'UserDestroyAccountModal',
  props: ['user'],
  components: {
    AlertWraper,
    Button,
    BaseIcon,
    WarningIcon
  },
  data () {
    return {
      options: [],
      confirmation: {
        option: null
      },
      loader: false,
      errors: null
    }
  },
  validations () {
    return {
      confirmation: {
        option: { checked: value => value === true }
      }
    }
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true,
        'modal-small': true
      }
    }
  },
  methods: {
    clearOptions () {
      this.errors = null
    },
    async submit () {
      this.loader = true
      try {
        const confirmation = await UserService.destroyAccount(this.user.id)
        this.$bvModal.hide('destroy-account')
        this.$emit('account-deleted', confirmation)
        AuthService.onLogout()
        this.$router.push('/')
        return location.reload()
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    hide () {
      this.clearOptions()
      this.$bvModal.hide('destroy-account')
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .modal-title {
    font-size: $font_size_medium;
  }

  ::v-deep {
    .styled-radio-as-input label {
      margin-bottom: 0;
    }
  }
</style>
